<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    message?: string
    imageAlt?: string
  }>(),
  {
    message: '',
    imageAlt: '',
  },
)

const { t } = useAppI18n()

const NO_DATA_IMAGE = 'https://resources1.interface003.com/web20/img/usercenter/no-data.png'

/** 空态默认文案复用项目通用“暂无数据”多语言。 */
const emptyMessage = computed(() => props.message || t('83714'))
</script>

<template>
  <div class="flex flex-col items-center justify-center py-[32px]">
    <CommonImage :src="NO_DATA_IMAGE" :alt="props.imageAlt" class="h-[130px] w-[230px]" />
    <p class="mt-[20px] text-center text-[14px] leading-[20px] text-[#4e5969]">{{ emptyMessage }}</p>
  </div>
</template>
